import { render, staticRenderFns } from "./checkAndRatify.vue?vue&type=template&id=28f99025&scoped=true&"
import script from "./checkAndRatify.vue?vue&type=script&lang=js&"
export * from "./checkAndRatify.vue?vue&type=script&lang=js&"
import style0 from "./checkAndRatify.vue?vue&type=style&index=0&id=28f99025&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f99025",
  null
  
)

export default component.exports